import { computed } from 'vue'
import { useUserStore } from '~/stores/useUserStore'
import { resolveLogoLink } from '~/utils/resolveLogoLink'
import { holdsCustomerRole } from '~/utils/holdsCustomerRole'
import { resolveRoleNames } from '~/utils/resolveRoleNames'
import { useIdentity } from '~/composables/useIdentity'

/**
 * The Sanctum identity is available as soon as the session resolves; the
 * Pinia store's user is only synced after `fetchUserAccess()` completes,
 * which several layouts only call from `onMounted` -- after this composable's
 * first render. Preferring the Sanctum identity (falling back to the store)
 * avoids a false "not a customer" read during that window, which would send
 * an authenticated customer's very first click to `/dashboard` instead of `/`.
 */
export const useLogoLink = () => {
  const { isAuthenticated, identity } = useIdentity()
  const userStore = useUserStore()

  const isCustomerRole = computed(() => {
    const resolvedUser = identity.value ?? userStore.user
    return holdsCustomerRole(resolveRoleNames(resolvedUser))
  })
  const logoLink = computed(() => resolveLogoLink(isAuthenticated.value, isCustomerRole.value))

  return { logoLink }
}
